import isString from "lodash/isString";
import styles from "./MonthSelectorInput.module.scss";
import { HTMLProps, forwardRef, useMemo } from "react";
import { InputWithIcon } from "src/components";
import { formatToMonthFullYearDate } from "src/utils";

type Props = HTMLProps<HTMLDivElement>;

export const MonthSelectorInput = forwardRef<HTMLDivElement, Props>(
  ({ onClick, onChange, placeholder, value }, ref) => {
    const formattedValue = useMemo<string>(() => {
      if (!isString(value)) return "";

      const result = formatToMonthFullYearDate(value);

      return result;
    }, [value]);

    return (
      <div
        className={styles.wrapper}
        onClick={onClick}
        onChange={onChange}
        ref={ref}
      >
        <InputWithIcon
          inputClassName={styles.input}
          value={formattedValue}
          icon="CalendarOutline"
          placeholder={placeholder}
          readOnly
        />
      </div>
    );
  },
);
